module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousQuotation
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Goods Receipt Form")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  })], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.vehicleBooking.allModuleId ? this.vehicleBooking.allModuleId : '',
      "jobSeriesBanner": this.vehicleBooking.bookingNo ? this.vehicleBooking.bookingNo : '',
      "bannerClientName": this.vehicleBooking.shipperCustomerName ?
        this.vehicleBooking.shipperCustomerName :
        '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('div', [(
    _vm.vehicleBooking.noOfTrucks != _vm.showGRNList.length &&
    _vm.goodReceived.goodReceivedID == ''
  ) ? _c('b-alert', {
    staticStyle: {
      "background-color": "red !important",
      "padding": "0.45rem 1rem !important",
      "margin-bottom": "3px !important"
    },
    attrs: {
      "id": "1",
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v("\n          Please Enter " + _vm._s(_vm.pendingGrn) + " Vehicle Details to Proceed Further..!\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.vehicleBooking.noOfTrucks == _vm.showGRNList.length &&
    _vm.goodReceived.goodReceivedID == ''
  ) ? _c('b-alert', {
    staticStyle: {
      "background-color": "#002b4954 !important",
      "padding": "0.45rem 1rem !important",
      "margin-bottom": "3px !important"
    },
    attrs: {
      "id": "1",
      "variant": "success",
      "show": ""
    }
  }, [_c('span', [_vm._v(" All Vehicle Details Added Successfully.You can Proceed Further ")])]) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(
    _vm.vehicleBooking.noOfTrucks != _vm.showGRNList.length ||
    _vm.goodReceived.goodReceivedID != ''
  ) ? _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("Transportation By *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.goodReceived.goodReceivedID != '' && _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ? true : false,
      "list": _vm.TPTtypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": _vm.changeDataOnTPTType
    },
    model: {
      value: (_vm.goodReceived.tptType),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "tptType", $$v)
      },
      expression: "goodReceived.tptType"
    }
  }), _vm._v(" "), (!_vm.goodReceived.tptType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.tptTypeError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoContainerType"
    }
  }, [_vm._v("Skip GRN")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": (_vm.goodReceived.tptType == '3') ? true : (_vm.goodReceived.goodReceivedID != '' && _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ? true : false),
      "list": _vm.skipGRNList,
      "option-value": "val",
      "option-text": "text",
      "placeholder": "Select "
    },
    on: {
      "input": _vm.clearFuelSlip
    },
    model: {
      value: (_vm.goodReceived.skipGRN),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "skipGRN", $$v)
      },
      expression: "goodReceived.skipGRN"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoContainerType"
    }
  }, [_vm._v("Movement Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "list": _vm.movementTypeList,
      "option-value": "val",
      "option-text": "text",
      "placeholder": "Select "
    },
    model: {
      value: (_vm.goodReceived.movementType),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "movementType", $$v)
      },
      expression: "goodReceived.movementType"
    }
  }), _vm._v(" "), (!_vm.goodReceived.movementType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.movementTypeError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.goodReceived.skipGRN != '1') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("GRN Date")]), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('date-picker', {
    attrs: {
      "disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "width": "100%",
      "type": "date",
      "id": "Date",
      "placeholder": "GRN Date"
    },
    model: {
      value: (_vm.goodReceived.Date),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "Date", $$v)
      },
      expression: "goodReceived.Date"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.goodReceived.Date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.DateError) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.goodReceived.tptType == '1' || _vm.goodReceived.tptType == '3') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "refuelData"
    }
  }, [_vm._v("Re-Fueling Station Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "list": _vm.refuelStationArrList,
      "option-value": "refuelStationId",
      "option-text": "vendorName",
      "placeholder": "Select Refuel  Station"
    },
    model: {
      value: (_vm.refuelData),
      callback: function($$v) {
        _vm.refuelData = $$v
      },
      expression: "refuelData"
    }
  }), _vm._v(" "), (!_vm.goodReceived.reFuelstation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.reFuelstationError) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.goodReceived.tptType == '2' || _vm.goodReceived.tptType == '3') && _vm.goodReceived.skipGRN == '1') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Outsource GRN No. *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "name": "Date",
      "id": "Date"
    },
    model: {
      value: (_vm.goodReceived.outSourceGRNo),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "outSourceGRNo", $$v)
      },
      expression: "goodReceived.outSourceGRNo"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.outSourceGRNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.outGrNoError) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.goodReceived.tptType == '1' || _vm.goodReceived.tptType == '3') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Re-Fueling Station Address")]), _vm._v(" "), _c('b-form-textarea', {
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "name": "refuelAddress",
      "id": "refuelAddress"
    },
    model: {
      value: (_vm.goodReceived.refuelAddress),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "refuelAddress", $$v)
      },
      expression: "goodReceived.refuelAddress"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.goodReceived.tptType == '2' || _vm.goodReceived.tptType == '3') && _vm.goodReceived.skipGRN == '1') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Outsource GRN Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "width": "100%",
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "pickupDate",
      "minute-step": 1,
      "name": "pickupDate"
    },
    model: {
      value: (_vm.goodReceived.outSourceGRNDate),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "outSourceGRNDate", $$v)
      },
      expression: "goodReceived.outSourceGRNDate"
    }
  }), _vm._v(" "), (!_vm.goodReceived.outSourceGRNDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.outSourceGRNDateError) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.goodReceived.tptType == '2')) ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Outsource Vehicle No. *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "name": "refuelAddress",
      "id": "refuelAddress"
    },
    model: {
      value: (_vm.goodReceived.outSourceVehicleNo),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "outSourceVehicleNo", $$v)
      },
      expression: "goodReceived.outSourceVehicleNo"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.outSourceVehicleNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.outSourceVehicleNoError) + "\n                ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.goodReceived.tptType == '1' || _vm.goodReceived.tptType == '3') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Advance Cash (Quotation)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "name": "advanceCash",
      "id": "advanceCash"
    },
    model: {
      value: (_vm.goodReceived.advanceCash),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "advanceCash", $$v)
      },
      expression: "goodReceived.advanceCash"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Actual cash Dispensed *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "name": "otherCashExpenses",
      "id": "otherCashExpenses"
    },
    on: {
      "keyup": _vm.finalActivityCost
    },
    model: {
      value: (_vm.goodReceived.otherCashExpenses),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "otherCashExpenses", $$v)
      },
      expression: "goodReceived.otherCashExpenses"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.otherCashExpenses) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.otherCashExpensesError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Diesel (in Ltr.)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "type": "number",
      "min": "0",
      "name": "diesel",
      "id": "diesel"
    },
    on: {
      "keyup": _vm.finalActivityCost
    },
    model: {
      value: (_vm.goodReceived.diesel),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "diesel", $$v)
      },
      expression: "goodReceived.diesel"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Actual Diesel Dispensed *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "name": "dieselPrice",
      "id": "dieselPrice"
    },
    on: {
      "keyup": _vm.finalActivityCost
    },
    model: {
      value: (_vm.goodReceived.dieselPrice),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "dieselPrice", $$v)
      },
      expression: "goodReceived.dieselPrice"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.dieselPrice) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.dieselPriceError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Toll in cash *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "name": "tollInCash",
      "id": "tollInCash"
    },
    on: {
      "keyup": _vm.finalActivityCost
    },
    model: {
      value: (_vm.goodReceived.tollInCash),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "tollInCash", $$v)
      },
      expression: "goodReceived.tollInCash"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.tollInCash) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.tollInCashError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Amount Paid in Cash for Diesel *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "name": "cashDeiselPaid",
      "id": "cashDeiselPaid"
    },
    on: {
      "keyup": _vm.finalActivityCost
    },
    model: {
      value: (_vm.goodReceived.cashDeiselPaid),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "cashDeiselPaid", $$v)
      },
      expression: "goodReceived.cashDeiselPaid"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.cashDeiselPaid) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.cashDeiselPaidError) + "\n                ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.goodReceived.tptType == '1' || _vm.goodReceived.tptType == '3') ? _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.goodReceived.goodReceivedID != '') ? _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Booked Vehicle")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "regdNo",
      "id": "regdNo",
      "disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    model: {
      value: (_vm.goodReceived.regdNo),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "regdNo", $$v)
      },
      expression: "goodReceived.regdNo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.goodReceived.goodReceivedID != "" ? "Change" : "") + "\n                    Vehicle No. *\n                  ")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.grnVehicleList,
      "option-value": "vehicleTruckId",
      "option-text": "regdNo",
      "placeholder": "Select Vehicle "
    },
    on: {
      "input": _vm.fetchDriverFromVehicle
    },
    model: {
      value: (_vm.goodReceived.vehicleTruckId),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "vehicleTruckId", $$v)
      },
      expression: "goodReceived.vehicleTruckId"
    }
  }), _vm._v(" "), (!_vm.goodReceived.vehicleTruckId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.vehicleTruckIdError) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), (_vm.goodReceived.goodReceivedID != '') ? _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('label', {
    staticClass: "mb-0"
  }, [_vm._v("Booked Driver")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "regdNo",
      "id": "regdNo",
      "disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    model: {
      value: (_vm.goodReceived.driverName),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "driverName", $$v)
      },
      expression: "goodReceived.driverName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('label', {
    staticClass: "mb-0",
    attrs: {
      "for": "assignDriverId"
    }
  }, [_vm._v("Driver Name")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openDriverModal()
      }
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v("Add Driver\n                      ")], 1)], 1), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.assignedDriverAll,
      "option-value": "driverId",
      "option-text": "driverName",
      "placeholder": "Select Driver",
      "isDisabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    model: {
      value: (_vm.goodReceived.driverId),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "driverId", $$v)
      },
      expression: "goodReceived.driverId"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }), _vm._v(" "), (_vm.checkCargo == true) ? _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('label', {
    staticClass: "mb-0",
    attrs: {
      "for": "assignDriverId"
    }
  }, [_vm._v("Assigned Driver Name ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.assignedDriverAll,
      "option-value": "driverId",
      "option-text": "driverName",
      "placeholder": "Select Driver"
    },
    model: {
      value: (_vm.goodReceived.assignDriverId),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "assignDriverId", $$v)
      },
      expression: "goodReceived.assignDriverId"
    }
  }), _vm._v(" "), (!_vm.goodReceived.assignDriverId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.assignDriverIdError) + "\n                  ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.goodReceived.goodReceivedID == '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), (_vm.goodReceived.driverId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    staticStyle: {
      "margin-top": "-6px"
    },
    attrs: {
      "id": "my-test9",
      "name": "my-test9"
    },
    on: {
      "change": _vm.showMultipleCargo
    },
    model: {
      value: (_vm.checkCargo),
      callback: function($$v) {
        _vm.checkCargo = $$v
      },
      expression: "checkCargo"
    }
  }, [_vm._v("Assign New Driver")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.goodReceived.tptType == '3') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transporter Name *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "name": "refuelAddress",
      "id": "refuelAddress"
    },
    model: {
      value: (_vm.goodReceived.transporterName),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "transporterName", $$v)
      },
      expression: "goodReceived.transporterName"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.transporterName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.transporterNameError) + "\n                  ")]) : _vm._e()], 1)], 1) : _vm._e()], 1) : _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transporter Name *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "name": "refuelAddress",
      "id": "refuelAddress"
    },
    model: {
      value: (_vm.goodReceived.transporterName),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "transporterName", $$v)
      },
      expression: "goodReceived.transporterName"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.transporterName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.transporterNameError) + "\n                  ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoContainerType"
    }
  }, [_vm._v("Container Size-Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "list": _vm.containerList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container"
    },
    on: {
      "input": _vm.masterCallbackContainer
    },
    model: {
      value: (_vm.AutoContainerType),
      callback: function($$v) {
        _vm.AutoContainerType = $$v
      },
      expression: "AutoContainerType"
    }
  }), _vm._v(" "), (_vm.goodReceived.multipleContainerType.length == 0) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ContainerSizeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No. (AAAA1234567) *")]), _vm._v(" "), _c('b-form-radio-group', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.contTypeList,
      "value-field": "Val",
      "text-field": "Text",
      "disabled-field": "notEnabled",
      "disabled": (_vm.goodReceived.goodReceivedID != '') ? true : false
    },
    on: {
      "input": function($event) {
        _vm.getContainerText()
      }
    },
    model: {
      value: (_vm.goodReceived.cont_input_type),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "cont_input_type", $$v)
      },
      expression: "goodReceived.cont_input_type"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": (_vm.goodReceived.goodReceivedID != '' &&
          _vm.$sessionsStorage.get('designation') != 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh') ||
        (_vm.goodReceived.shipmentType == '1' &&
          _vm.goodReceived.NewContainerTypeId.indexOf('15') >= 0 &&
          _vm.goodReceived.transportType == 'Export' &&
          _vm.goodReceived.containerInfo == 'lcl' &&
          _vm.$sessionsStorage.get('designation') != 'Admin') ||
        (_vm.goodReceived.cont_input_type !== 'Container') ?
        true :
        false,
      "name": "containerNo",
      "id": "containerNo"
    },
    on: {
      "keyup": function($event) {
        _vm.containerNoRegexfun()
      }
    },
    model: {
      value: (_vm.goodReceived.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "containerNo", $$v)
      },
      expression: "goodReceived.containerNo"
    }
  }), _vm._v(" "), (_vm.checkContNoButton == 3 || _vm.checkContNoButton == 2) ? _c('b', {
    class: _vm.checkContNoButton == 1 ? 'success' : 'error'
  }, [_vm._v("\n                    " + _vm._s(_vm.timmerMsg) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), (!_vm.goodReceived.containerNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.containerNoError) + "\n                ")]) : (_vm.containerNoRegexError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.containerNoRegexError) + "\n                ")]) : _vm._e(), _vm._v(" "), (
    _vm.containerNoRegexError == '' &&
    _vm.goodReceived.containerNo != '' &&
    _vm.goodReceived.containerNo != _vm.algoConNo &&
    _vm.showAlgo == true
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  Note:System Generated Container No. is :\n                  " + _vm._s(_vm.algoConNo) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), (
    _vm.containerNoRegexError == '' &&
    _vm.goodReceived.containerNo != '' &&
    _vm.goodReceived.multipleContainerType.length > 1 &&
    _vm.totalCon == ''
  ) ? _c('md-layout', {
    staticStyle: {
      "margin-top": "35px"
    },
    attrs: {
      "md-flex": "10"
    }
  }, [(_vm.goodReceived.goodReceivedID == '') ? _c('b-button', {
    attrs: {
      "variant": "outline-dark",
      "size": "sm"
    },
    on: {
      "click": _vm.shiftContainer
    }
  }, [_vm._v("Add Another")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.totalCon != '') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Second Container No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "name": "containerNo",
      "id": "containerNo"
    },
    model: {
      value: (_vm.totalCon),
      callback: function($$v) {
        _vm.totalCon = $$v
      },
      expression: "totalCon"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }, [(_vm.totalCon != '') ? _c('b-button', {
    staticStyle: {
      "margin-top": "35px"
    },
    attrs: {
      "variant": "info",
      "size": "sm"
    },
    on: {
      "click": _vm.clear2Con
    }
  }, [_vm._v("Clear")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.goodReceived.multipleContainerType.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2 mt-2",
    attrs: {
      "md-flex": "40"
    }
  }, _vm._l((_vm.goodReceived.multipleContainerType), function(type, index) {
    return _c('md-chip', {
      key: index,
      attrs: {
        "md-deletable": "",
        "disabled": _vm.goodReceived.goodReceivedID == '' ? false : true
      },
      on: {
        "delete": function($event) {
          _vm.deleteContainer(type, index)
        }
      }
    }, [_vm._v(_vm._s(type))])
  }))], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Vehicle Type. *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.goodReceived.goodReceivedID &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "list": _vm.grnVehicleList,
      "option-value": "vehicleType",
      "option-text": "vehicleType",
      "placeholder": "Select Vehicle Type"
    },
    model: {
      value: (_vm.goodReceived.vehicleType),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "vehicleType", $$v)
      },
      expression: "goodReceived.vehicleType"
    }
  }), _vm._v(" "), (!_vm.goodReceived.vehicleType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.vehicleTypeError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "75"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Description.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "state": _vm.goodReceived.Description.length >= 30,
      "maxlength": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        '90' :
        '',
      "formatter": _vm.capitalizeAll,
      "name": "consignorAddress",
      "id": "consignorAddress",
      "placeholder": "Please Enter Description",
      "rows": "1",
      "max-rows": "1",
      "no-resize": ""
    },
    model: {
      value: (_vm.goodReceived.Description),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "Description", $$v)
      },
      expression: "goodReceived.Description"
    }
  }), _vm._v(" "), (!_vm.goodReceived.Description) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.DescriptionError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Consignee.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "consignorAddress",
      "id": "consignorAddress",
      "placeholder": "Please Enter Consignee Details"
    },
    model: {
      value: (_vm.goodReceived.consignee),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "consignee", $$v)
      },
      expression: "goodReceived.consignee"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Consignor.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "consignor",
      "id": "consignor",
      "placeholder": "Please Enter Consignor Details"
    },
    model: {
      value: (_vm.goodReceived.consignor),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "consignor", $$v)
      },
      expression: "goodReceived.consignor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("G. Wt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "containerNo",
      "id": "containerNo"
    },
    model: {
      value: (_vm.goodReceived.weight),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "weight", $$v)
      },
      expression: "goodReceived.weight"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Remark.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "consignorAddress",
      "id": "consignorAddress",
      "placeholder": "Please Enter Remark Details"
    },
    model: {
      value: (_vm.goodReceived.weight_remark),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "weight_remark", $$v)
      },
      expression: "goodReceived.weight_remark"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (
    (_vm.goodReceived.containerInfo == 'fcl' ||
      _vm.goodReceived.containerInfo == '') &&
    _vm.goodReceived.NewContainerTypeId.indexOf('15') < 0
  ) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "slineName"
    }
  }, [_vm._v("Shipping-Line Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "list": _vm.ShippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.goodReceived.slineName),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "slineName", $$v)
      },
      expression: "goodReceived.slineName"
    }
  }), _vm._v(" "), (!_vm.goodReceived.slineName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.slineNameError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("S-Line Seal Number *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "name": "slineSealNo",
      "id": "slineSealNo"
    },
    model: {
      value: (_vm.goodReceived.slineSealNo),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "slineSealNo", $$v)
      },
      expression: "goodReceived.slineSealNo"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.slineSealNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.slineSealNoError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "Disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "formatter": _vm.capitalizeAll,
      "name": "customClearenceNo",
      "id": "customClearenceNo"
    },
    model: {
      value: (_vm.goodReceived.customSealNo),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "customSealNo", $$v)
      },
      expression: "goodReceived.customSealNo"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Arrival at Factory")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "width": "100%",
      "lang": "en",
      "format": _vm.selectDateFormat,
      "type": "datetime",
      "id": "factoryDate",
      "disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    model: {
      value: (_vm.goodReceived.factoryInDate),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "factoryInDate", $$v)
      },
      expression: "goodReceived.factoryInDate"
    }
  }), _vm._v(" "), (!_vm.goodReceived.factoryInDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.factoryInDateError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Dispatch from Factory")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "width": "100%",
      "type": "date",
      "id": "factoryOutDate"
    },
    model: {
      value: (_vm.goodReceived.factoryOutDate),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "factoryOutDate", $$v)
      },
      expression: "goodReceived.factoryOutDate"
    }
  }), _vm._v(" "), (!_vm.goodReceived.factoryOutDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.factoryOutDateError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Fuel Slip No. *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "FuelSlipNo",
      "id": "FuelSlipNo",
      "disabled": true
    },
    model: {
      value: (_vm.goodReceived.FuelSlipNo),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "FuelSlipNo", $$v)
      },
      expression: "goodReceived.FuelSlipNo"
    }
  })], 1), _vm._v(" "), (!_vm.goodReceived.FuelSlipNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.FuelSlipNoError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.goodReceived.goodReceivedID != '') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Vehicle Status *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusV",
      "option-text": "statusT",
      "placeholder": "Select Vehicle Status",
      "isDisabled": _vm.goodReceived.vehicleReleaseDateAdded == 1 &&
        _vm.goodReceived.goodReceivedID != '' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    model: {
      value: (_vm.goodReceived.status),
      callback: function($$v) {
        _vm.$set(_vm.goodReceived, "status", $$v)
      },
      expression: "goodReceived.status"
    }
  }), _vm._v(" "), (!_vm.vehicleBooking.status) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.statusError) + "\n                ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.checkContNoButton != 1 ? true : false,
      "variant": "primary",
      "size": "sm",
      "id": "addButtonLoader11"
    },
    on: {
      "click": _vm.generateGrnForm
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.goodReceived.goodReceivedID == "" ? "Generate" : "Generate") + "\n                  GRN\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.goodReceived.UpdateReason))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader11"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error mt-5 ml-2"
  }, [_vm._v("\n                  " + _vm._s(_vm.containerNoRegexError) + "\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.goodReceived.goodReceivedID == '') ? _c('div', [(_vm.showGRNList.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [(_vm.showGRNList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-2",
    attrs: {
      "variant": "outline-info",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.goToMailPage('T')
      }
    }
  }, [_vm._v("Track Assignment")]) : _vm._e(), _vm._v(" "), (_vm.showGRNList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-2",
    attrs: {
      "variant": "outline-info",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.goToMailPage('M')
      }
    }
  }, [_vm._v("Send GRN Consolidation Mail")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "truckDetail2"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("GRN Details")]), _vm._v(" "), _c('th', [_vm._v("Other Details")]), _vm._v(" "), _c('th', [_vm._v("Transportation By")]), _vm._v(" "), _c('th', [_vm._v("Transporter Name")]), _vm._v(" "), _c('th', [_vm._v("Vehicle Status")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Print")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.showGRNList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("GRN No. :")]), _vm._v("\n                        " + _vm._s(item.GRNSeries) + "\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("GRN Date :")]), _vm._v("\n                        " + _vm._s(_vm._f("moment")(item.Date)) + "\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Vehicle No. :")]), _vm._v("\n                        " + _vm._s(item.regdNo != null && item.regdNo != "" ?
      item.regdNo :
      item.vehicleNo) + "\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Driver Name :")]), _vm._v("\n                        " + _vm._s(item.driverName) + "\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Assigned Driver Name :")]), _vm._v("\n                        " + _vm._s(item.assignedDriverName != "" ? item.assignedDriverName : "NA") + "\n                      ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Fuel Slip No. :")]), _vm._v("\n                        " + _vm._s(item.FuelSlipNo) + "\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Container No. :")]), _vm._v("\n                        " + _vm._s(item.containerNo) + " (" + _vm._s(item.multipleContainerType) + ")\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Shipping Line Name :")]), _vm._v("\n                        " + _vm._s(item.shippingLine) + "\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Shipping Line Seal No. :")]), _vm._v("\n                        " + _vm._s(item.slineSealNo) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tptType == 1 ? "Pridel" : item.tptType == 3 ? "PRIDEL HIRING" : item.tptType == 2 ? "OutSourced" : ""))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.transporterName == "" ? "NA" : item.transporterName) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.status == 1 ?
      "In Transit" :
      "Closed (Vehicle Reached At Destination)") + "\n                      ")]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-info"
      },
      on: {
        "click": function($event) {
          _vm.showGRN(item)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), (
      _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
      _vm.$sessionsStorage.get('designation') == 'Admin'
    ) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-info"
      },
      on: {
        "click": function($event) {
          _vm.openModalGRNNO(item)
        }
      }
    }, [_vm._v("Reset GRN No")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.skipGRN == '0') ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.Print(item.pdfGRN)
        }
      }
    }, [_vm._v("GRN PDF")]) : _vm._e()], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.vehicleBooking.noOfTrucks == _vm.showGRNList.length) ? _c('md-layout', {
    staticClass: "mrgtop-2per justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.permissionStatus,
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.goodsReceived
    }
  }, [_vm._v("Save & Proceed")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Reset-GRNNO-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "id": "modal-multi-2",
      "size": "lg",
      "title": 'Reset GRNNO  : ' + _vm.UpdateGRNDetails.previousGRNNo
    }
  }, [_c('label', {
    attrs: {
      "for": "validBookingNo"
    }
  }, [_vm._v(" GRN Count ")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "type": "number",
      "id": "grnIdNew",
      "name": "grnIdNew"
    },
    model: {
      value: (_vm.UpdateGRNDetails.grnIdNew),
      callback: function($$v) {
        _vm.$set(_vm.UpdateGRNDetails, "grnIdNew", $$v)
      },
      expression: "UpdateGRNDetails.grnIdNew"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideModalGRNNO
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4 ml-auto",
    attrs: {
      "size": "sm",
      "variant": "outline-success"
    },
    on: {
      "click": _vm.ResetGRNNO
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "Driver-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.isEditMode ? 'Edit Driver' : 'Add Driver'
    },
    on: {
      "hidden": _vm.resetDriverModal
    }
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addDriver($event)
      }
    }
  }, [_c('h6', {
    staticClass: "text-primary mb-3"
  }, [_vm._v("Basic Information")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Location "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "location",
      "name": "location",
      "placeholder": "Enter Location",
      "state": !_vm.errorList.location
    },
    model: {
      value: (_vm.driverModal.location),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "location", $$v)
      },
      expression: "driverModal.location"
    }
  }), _vm._v(" "), (_vm.errorList.location) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.location))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "vehicleNumber",
      "name": "vehicleNumber",
      "placeholder": "Enter Vehicle Number"
    },
    model: {
      value: (_vm.driverModal.vehicleNumber),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "vehicleNumber", $$v)
      },
      expression: "driverModal.vehicleNumber"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Driver Type "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "size": "sm",
      "id": "driverType",
      "name": "driverType",
      "options": _vm.driverTypeOptions,
      "state": !_vm.errorList.driverType
    },
    model: {
      value: (_vm.driverModal.driverType),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "driverType", $$v)
      },
      expression: "driverModal.driverType"
    }
  }), _vm._v(" "), (_vm.errorList.driverType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.driverType))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("E.Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "eCode",
      "name": "eCode",
      "placeholder": "Enter E.Code"
    },
    model: {
      value: (_vm.driverModal.eCode),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "eCode", $$v)
      },
      expression: "driverModal.eCode"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Name of Driver "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "driverName",
      "name": "driverName",
      "placeholder": "Enter Driver Name",
      "state": !_vm.errorList.driverName
    },
    model: {
      value: (_vm.driverModal.driverName),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "driverName", $$v)
      },
      expression: "driverModal.driverName"
    }
  }), _vm._v(" "), (_vm.errorList.driverName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.driverName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Father's Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "fathersName",
      "name": "fathersName",
      "placeholder": "Enter Father's Name",
      "state": !_vm.errorList.fathersName
    },
    model: {
      value: (_vm.driverModal.fathersName),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "fathersName", $$v)
      },
      expression: "driverModal.fathersName"
    }
  }), _vm._v(" "), (_vm.errorList.fathersName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.fathersName))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('h6', {
    staticClass: "text-primary mb-3 mt-4"
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Mobile Number "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "mobileNumber",
      "name": "mobileNumber",
      "placeholder": "Enter Mobile Number",
      "state": !_vm.errorList.mobileNumber
    },
    on: {
      "blur": function($event) {
        _vm.validateMobile(_vm.driverModal.mobileNumber)
      }
    },
    model: {
      value: (_vm.driverModal.mobileNumber),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "mobileNumber", $$v)
      },
      expression: "driverModal.mobileNumber"
    }
  }), _vm._v(" "), (_vm.errorList.mobileNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.mobileNumber))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Date of Joining")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "date",
      "id": "dateOfJoining",
      "name": "dateOfJoining"
    },
    model: {
      value: (_vm.driverModal.dateOfJoining),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "dateOfJoining", $$v)
      },
      expression: "driverModal.dateOfJoining"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Date of Leaving")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "date",
      "id": "dateOfLeaving",
      "name": "dateOfLeaving"
    },
    model: {
      value: (_vm.driverModal.dateOfLeaving),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "dateOfLeaving", $$v)
      },
      expression: "driverModal.dateOfLeaving"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "date",
      "id": "dateOfBirth",
      "name": "dateOfBirth"
    },
    model: {
      value: (_vm.driverModal.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "dateOfBirth", $$v)
      },
      expression: "driverModal.dateOfBirth"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Aadhar Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "aadharNo",
      "name": "aadharNo",
      "placeholder": "XXXX-XXXX-XXXX"
    },
    on: {
      "blur": function($event) {
        _vm.validateAadhar(_vm.driverModal.aadharNo)
      }
    },
    model: {
      value: (_vm.driverModal.aadharNo),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "aadharNo", $$v)
      },
      expression: "driverModal.aadharNo"
    }
  }), _vm._v(" "), (_vm.errorList.aadharNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.aadharNo))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("UAN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "uanNumber",
      "name": "uanNumber",
      "placeholder": "Enter UAN Number"
    },
    model: {
      value: (_vm.driverModal.uanNumber),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "uanNumber", $$v)
      },
      expression: "driverModal.uanNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("E.S.I. Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "esiNo",
      "name": "esiNo",
      "placeholder": "Enter ESI Number"
    },
    model: {
      value: (_vm.driverModal.esiNo),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "esiNo", $$v)
      },
      expression: "driverModal.esiNo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("DL Number "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "dlNumber",
      "name": "dlNumber",
      "placeholder": "Enter DL Number",
      "state": !_vm.errorList.dlNumber
    },
    on: {
      "blur": function($event) {
        _vm.validateDL(_vm.driverModal.dlNumber)
      }
    },
    model: {
      value: (_vm.driverModal.dlNumber),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "dlNumber", $$v)
      },
      expression: "driverModal.dlNumber"
    }
  }), _vm._v(" "), (_vm.errorList.dlNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.dlNumber))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.isSubmitting,
      "size": "sm"
    }
  }, [(_vm.isSubmitting) ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.isSubmitting ? 'Saving...' : (_vm.isEditMode ? 'Update Driver' : 'Save Driver')) + "\n          ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.hideDriverModal
    }
  }, [_vm._v("\n            Cancel\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose3
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop1",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose1
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e92b86c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/vehicleBooking.vue
// module id = 2546
// module chunks = 0